import PropTypes from 'prop-types';
import { ButtonTooltip } from '@evertrue/et-components';
import CompleteTaskToggle from '../../complete-task-toggle';

const TaskCheckboxCell = ({ task, user, onToggleCompletion }) => {
  if (!task) return null;

  const isOwnerOrCreator = task.owner_user_id === user.id || task.creator_user_id === user.id;

  if (isOwnerOrCreator) {
    return <CompleteTaskToggle task={task} onClick={onToggleCompletion} ownerUserId={task?.owner_user_id} />;
  }

  return (
    <ButtonTooltip
      trigger={<span className="dash-task-circle" />}
      children="Complete Task option is disabled because you are not the owner of this task"
    />
  );
};

TaskCheckboxCell.propTypes = {
  task: PropTypes.object,
  user: PropTypes.object,
  onToggleCompletion: PropTypes.func,
};

export default TaskCheckboxCell;
